// src/utils/typeSound.js
// 편지 타이핑 효과음 — 연필로 글씨 쓰는 소리 (Web Audio API)
// 톤(오실레이터) 대신, 종이를 긁는 듯한 "사각사각" 필터드 노이즈로 합성.

let audioCtx = null;
let noiseBuffer = null;
let lastPlay = 0;

function ensureCtx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  // 브라우저 자동재생 정책으로 정지된 경우 재개
  if (audioCtx.state === "suspended") {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

// 재사용할 화이트 노이즈 버퍼 (한 번만 생성)
function getNoiseBuffer(ctx) {
  if (noiseBuffer) return noiseBuffer;
  const len = Math.floor(ctx.sampleRate * 0.4); // 0.4초
  noiseBuffer = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = noiseBuffer.getChannelData(0);
  for (let i = 0; i < len; i++) {
    data[i] = Math.random() * 2 - 1;
  }
  return noiseBuffer;
}

export function playTypeClick() {
  try {
    const ctx = ensureCtx();
    const now = ctx.currentTime;

    // 과도한 중첩 방지(살짝 솎아내 더 자연스러운 필기 리듬)
    if (now - lastPlay < 0.028) return;
    lastPlay = now;

    const buffer = getNoiseBuffer(ctx);

    // 노이즈 버퍼의 임의 지점에서 짧게 재생 → 매번 다른 결의 긁힘
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const offset = Math.random() * 0.3;
    const dur = 0.03 + Math.random() * 0.035; // 30~65ms

    // 저음 럼블 제거
    const hp = ctx.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.setValueAtTime(700, now);

    // 연필이 종이를 긁는 거친 중·고역대 강조
    const band = ctx.createBiquadFilter();
    band.type = "bandpass";
    band.frequency.setValueAtTime(1500 + Math.random() * 1500, now); // 1.5~3.0kHz
    band.Q.setValueAtTime(0.6, now);

    // 음량 엔벨로프 — 빠른 어택, 짧은 감쇠 (작게)
    const gain = ctx.createGain();
    const peak = 0.022 + Math.random() * 0.014;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.linearRampToValueAtTime(peak, now + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.0006, now + dur);

    src.connect(hp);
    hp.connect(band);
    band.connect(gain);
    gain.connect(ctx.destination);

    src.start(now, offset, dur);
    src.stop(now + dur + 0.02);
  } catch {
    // 오디오 미지원 무시
  }
}
